import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/analytics';

const RouteTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const pageType = location.pathname === '/cv-ats'
      ? 'campaign_landing'
      : location.pathname === '/'
        ? 'homepage'
        : location.pathname.replace('/', '') || 'homepage';

    trackPageView(pageType);
  }, [location.pathname, location.search]);

  return null;
};

export default RouteTracker;
